@if (cartStateService.canBeVisible()) {
  @if (!cartStateService.isCartEmpty()) {
    <p-scrollPanel [style]="{'overflow-y': 'scroll', 'max-height': 'calc(100vh - 150px)'}">
      <ng-container>
        @if (cartModel().todaysCharges?.items.length) {
          <div class="flex flex-column">
            <div
              class="mb-2 flex justify-content-center align-items-center py-2 border-round-lg sara-header-bg">
              <span class="text-white font-bold">Today's charges</span>
            </div>
            <div class="border-1 border-round-xl border-black-alpha-20 bg-gray p-2 pb-0 mb-2">
              @for (pi of cartModel().todaysCharges?.items; track pi; let i = $index) {
                <div class="p-2 pb-0">
                  <div class="mb-1 flex justify-content-between font-bold">
                    <span>{{pi.name}}</span>
                    <span>{{pi.amount| currency}}</span>
                  </div>
                </div>
                @if (pi?.disclosure) {
                  <div class="flex pb-2 pl-3">
                    <span class="text-primary-700">{{pi.disclosure}}</span>
                    <!-- {{pi.Disclosure}} -->
                  </div>
                }
                @if (pi?.CartDisclosureList?.length > 0) {
                  <div class="fee-breakdown pb-2 pl-3 pr-4 text-900 text-sm font-normal"
                    >
                    @for (disclosure of pi.CartDisclosureList; track disclosure) {
                      <span class="mb-1">{{disclosure.Label}}</span>
                      <span class="fee-breakdown-amount mb-1 text-left white-space-nowrap">{{disclosure.Fee | currency}}</span>
                    }
                  </div>
                }
              }
              <div class="p-2" style="border-top: 1px solid;">
                <div class="mb-1 flex justify-content-between font-bold"
                  *ngClass="cartModel().todaysCharges?.totalTaxAmount">
                  <span>Tax </span>
                  <span>{{cartModel().todaysCharges?.totalTaxAmount| currency}} </span>
                </div>
                <div class="mb-1 flex justify-content-between font-bold">
                  <span>Today's Total** </span>
                  <span>{{cartModel().todaysCharges?.totalAmount| currency}} </span>
                </div>
              </div>
            </div>
          </div>
        }
        @if (cartModel().firstBillCharges?.items.length) {
          <div class="flex flex-column ">
            <div
              class="mb-2 flex justify-content-center align-items-center py-2 border-round-lg sara-header-bg">
              <span class="text-white font-bold">First Bill Charges</span>
            </div>
            <div class="border-1 border-round-xl border-black-alpha-20 bg-gray p-2 pb-0 mb-2">
              @for (pi of cartModel().firstBillCharges?.items; track pi; let i = $index) {
                <div class="p-2 pb-0">
                  <div class="mb-1 flex justify-content-between font-bold">
                    <span>{{pi.name}}</span>
                    <span>{{pi.amount | currency}}</span>
                  </div>
                </div>
                @if (pi?.disclosure) {
                  <div class="flex pb-2 pl-3 text-sm">
                    <span class="text-primary-700">{{pi.disclosure}}</span>
                    <!-- {{pi.Disclosure}} -->
                  </div>
                }
              }
              <div class="p-2" style="border-top: 1px solid;">
                @if (isCharter) {
                  <div class="mb-1 flex justify-content-between font-bold">
                    <span>One-Time Tax</span>
                    <span>{{cartModel().firstBillCharges?.totalTaxAmount ?? '0' | currency}}</span>
                  </div>
                }
                <div class="flex justify-content-between font-bold">
                  <span>Total* </span>
                  <span>{{cartModel().firstBillCharges?.totalAmount | currency}}</span>
                </div>
              </div>
              <div class="p-2 pt-0">
                <div class="mb-2">
                  <span>* Plus monthly </span>
                </div>
              </div>
            </div>
          </div>
        }
        <div class="flex flex-column  mt-2">
          <div
            class="mb-2 flex justify-content-center align-items-center py-2 border-round-lg sara-header-bg">
            <span class="text-white text-base font-semibold">Monthly Charges</span>
          </div>
        </div>
        @if (cartModel().internetCharges) {
          <div class="flex flex-column ">
            <div class="justify-content-center align-items-center mt-3 dashed">
              <div class="flex align-items-center justify-content-center mb-4">
                <div class="border-top-1 surface-800 flex-1 bg-black-alpha-40"></div>
                <span class="text-sm font-bold text-primary px-3">Internet</span>
                <div class="border-top-1 surface-800 flex-1 bg-black-alpha-40"></div>
              </div>
            </div>
            <div class="border-1 border-round-xl border-black-alpha-20 bg-gray p-2 pb-0 mb-2 p-3 border-round-xl text-sm font-semibold gap-3 flex flex-column"
              style="background-color: #F0F0F0;">
              <div class="p-2 pb-0">
                <div class="mb-2 flex justify-content-between font-bold">
                  <span>{{cartModel().internetCharges?.name}}</span>
                  <span>{{cartModel().internetCharges?.price | currency}} </span>
                </div>
              </div>
              @for (category of cartModel().internetCharges?.monthly?.items; track category) {
                <div>
                  <div class="p-2 pb-0">
                    <div class="mb-2 flex justify-content-between font-bold">
                      <span>{{category?.name}}</span>
                      <span>{{category?.amount | currency}}</span>
                    </div>
                  </div>
                  @if (category?.disclosure) {
                    <div class="flex pb-2 pl-3">
                      <span class="text-primary-700">{{category?.disclosure}}</span>
                    </div>
                  }
                </div>
              }
              @if (cartModel().internetCharges?.monthly?.promotions?.items?.length > 0) {
                <div class="w-full align-self-center p-4 border-round-lg bg-white">
                  <div class="flex flex-column gap-2 text-sm font-semibold">
                    <div class="flex flex-column">
                      <span class="font-bold">Promotions</span>
                    </div>
                    @for (promotion of cartModel().internetCharges?.monthly.promotions?.items; track promotion) {
                      <div class="flex justify-content-between">
                        <span>{{ promotion.name }}</span>
                        <span class="positive-base">{{ promotion.amount| currency }}</span>
                      </div>
                      @if (promotion.disclosure) {
                        <div class="font-light font-product">
                          <span [innerHTML]="promotion.disclosure"></span>
                        </div>
                      }
                    }
                    <p-divider class="flex justify-content-center w-full"></p-divider>
                    <div class="flex justify-content-between positive-base">
                      <span>Total Savings</span>
                      <span>{{ cartModel().internetCharges?.monthly?.promotions?.totalAmount |
                        currency
                      }}</span>
                    </div>
                  </div>
                </div>
              }
              <div class="p-2" style="border-top: 1px solid;">
                @if (isCharter) {
                  <div class="mb-2 flex justify-content-between font-bold">
                    <span>Monthly Tax</span>
                    <span>{{cartModel().internetCharges?.monthly?.totalTaxAmount ?? '0' | currency}}</span>
                  </div>
                }
                <div class="mb-2 flex justify-content-between font-bold">
                  <span>Total </span>
                  <span>{{cartModel().internetCharges?.monthly?.totalAmount | currency}} </span>
                </div>
              </div>
            </div>
          </div>
        }
      </ng-container>
      @if (cartModel().wirelessCharges?.monthly?.length) {
        <div>
          <div class="flex flex-column gap-2">
            <div class="justify-content-center align-items-center mt-3 dashed">
              <div class="flex align-items-center justify-content-center mb-4">
                <div class="border-top-1 surface-800 flex-1 bg-black-alpha-40"></div>
                <span class="text-sm font-bold text-primary px-3">Wireless</span>
                <div class="border-top-1 surface-800 flex-1 bg-black-alpha-40"></div>
              </div>
            </div>
            @for (lineData of cartModel().wirelessCharges?.monthly; track lineData; let index = $index) {
              @if (lineData.lineNumber > 0) {
                <div style="background-color: #F0F0F0;"
                  class="p-3 border-round-xl text-sm font-semibold gap-3 flex flex-column">
                  <div class="align-items-center flex gap-2 justify-content-center text-base font-semibold">
                    <span>Line {{ lineData.lineNumber }}</span>
                    @if (lineData.lineNumber === 1) {
                      <span> (Primary)</span>
                    }
                  </div>
                  <!-- Device Name -->
                  <div class="mb-2 flex justify-content-center font-bold">
                    <span>{{ lineData.device?.name }}
                      @if (lineData.device?.amount > 0) {
                        ({{ lineData.device?.amount|
                        currency }})
                      }</span>
                    </div>
                    @for (chargeItem of lineData.charges?.items; track chargeItem) {
                      <div>
                        <div class="p-2 pb-0">
                          <div class="mb-2 flex justify-content-between font-bold">
                            <span>{{chargeItem?.name}}</span>
                            <span>{{chargeItem?.amount | currency}}</span>
                          </div>
                        </div>
                        @if (chargeItem?.disclosure) {
                          <div class="flex pb-2 pl-3">
                            <span class="text-primary-700">{{chargeItem?.disclosure}}</span>
                          </div>
                        }
                        @if (chargeItem?.CartDisclosureList?.length > 0) {
                          <div class="fee-breakdown pb-2 pl-3 pr-4 text-900 text-sm font-normal"
                            >
                            @for (disclosure of chargeItem.CartDisclosureList; track disclosure) {
                              <span class="mb-1">{{disclosure.Label}}</span>
                              <span class="fee-breakdown-amount mb-1 text-left white-space-nowrap">{{disclosure.Fee | currency}}</span>
                            }
                          </div>
                        }
                      </div>
                    }
                    @if (lineData.promotions?.items?.length > 0) {
                      <div class="w-full align-self-center p-4 border-round-lg bg-white">
                        <div class="flex flex-column gap-2 text-sm font-semibold">
                          <div class="flex flex-column">
                            <span class="font-bold">Promotions</span>
                          </div>
                          @for (promotion of lineData.promotions?.items; track promotion) {
                            <div class="flex justify-content-between">
                              <span>{{ promotion.name }}</span>
                              <span class="positive-base">{{ promotion.amount| currency }}</span>
                            </div>
                            @if (promotion.disclosure) {
                              <div class="font-light font-product">
                                <span [innerHTML]="promotion.disclosure"></span>
                              </div>
                            }
                          }
                          <!-- Trade-In -->
                          @if (lineData.tradeIn) {
                            <div
                              class="w-full align-self-center border-round-lg border-1 p-2 border-black-alpha-20">
                              <div class="flex flex-column gap-2 text-sm font-semibold">
                                <div class="flex justify-content-between">
                                  <span class="font-bold">Trade-In</span>
                                  <span>{{ lineData.tradeIn.model }}</span>
                                </div>
                                <div class="flex justify-content-between">
                                  <span>Trade-In Value</span>
                                  <span class="positive-base">{{ lineData.tradeIn.tradeInValue |
                                  currency }}</span>
                                </div>
                                @if (lineData.tradeIn.promoDiscount) {
                                  <div class="flex justify-content-between"
                                    >
                                    <span>Promo Discount</span>
                                    <span class="positive-base">{{ lineData.tradeIn.promoDiscount |
                                    currency }}</span>
                                  </div>
                                }
                                @if (lineData.tradeIn.monthlyCredit > 0) {
                                  <div class="font-light font-product"
                                    >
                                    <span>{{ lineData.tradeIn.monthlyCredit | currency }} credit for
                                      {{ lineData.tradeIn.financingMonths }} months (Applied
                                    within 2-3 Billing Cycles)</span>
                                  </div>
                                }
                              </div>
                            </div>
                          }
                          <p-divider class="flex justify-content-center w-full"></p-divider>
                          <div class="flex justify-content-between positive-base">
                            <span>Total Savings</span>
                            <span>{{ (lineData.promotions?.totalAmount || 0) | currency }}</span>
                          </div>
                        </div>
                      </div>
                    }
                    <p-divider class="flex justify-content-center w-full no-margin-divider"></p-divider>
                    <!-- Line Total -->
                    <div class="flex justify-content-between">
                      <span>Total</span>
                      <span>{{ lineData?.totalAmount| currency }}</span>
                    </div>
                  </div>
                }
              }
            </div>
            <!-- <app-wireless-cart (wirelessCartUpdated)="onWirelessCartUpdated($event)"></app-wireless-cart> -->
          </div>
        }
        @if (cartModel().videoCharges) {
          <div class="flex flex-column ">
            <div class="justify-content-center align-items-center mt-3 dashed">
              <div class="flex align-items-center justify-content-center mb-4">
                <div class="border-top-1 surface-800 flex-1 bg-black-alpha-40"></div>
                <span class="text-sm font-bold text-primary px-3">Video</span>
                <div class="border-top-1 surface-800 flex-1 bg-black-alpha-40"></div>
              </div>
            </div>
            <div class="border-1 border-round-xl border-black-alpha-20 bg-gray p-2 pb-0 mb-2 p-3 border-round-xl text-sm font-semibold gap-3 flex flex-column"
              style="background-color: #F0F0F0;">
              @if(!cartModel().videoCharges?.hideMainPackage) {
                <div class="p-2 pb-0">
                  <div class="mb-2 flex justify-content-between font-bold">
                    <span [innerHTML]="cartModel().videoCharges?.name"></span>
                    <span>{{cartModel().videoCharges?.price | currency}} </span>
                  </div>
                </div>
              }
              @for (category of cartModel().videoCharges?.monthly?.items; track category) {
                <div>
                  <div class="p-2 pb-0">
                    <div class="mb-2 flex justify-content-between font-bold">
                      <span [innerHTML]="category?.name"></span>
                      @if (category?.showIncludedLabel) {
                        <span>Included</span>
                      } @else {
                        <span>{{category?.amount | currency}}</span>
                      }
                    </div>
                  </div>
                  @if (category?.disclosure) {
                    <div class="flex pb-2 pl-3">
                      <span class="text-primary-700" [innerHTML]="category?.disclosure"></span>
                    </div>
                  }
                  @if (category?.CartDisclosureList?.length > 0) {
                    <div class="fee-breakdown pb-2 pl-3 pr-4 text-900 text-sm font-normal"
                      >
                      @for (disclosure of category.CartDisclosureList; track disclosure) {
                        <span class="mb-1">{{disclosure.Label}}</span>
                        <span class="fee-breakdown-amount mb-1 text-left white-space-nowrap">{{disclosure.Fee | currency}}</span>
                      }
                    </div>
                  }
                </div>
              }
              @if (cartModel().videoCharges?.monthly?.promotions?.items?.length > 0) {
                <div class="w-full align-self-center p-4 border-round-lg bg-white">
                  <div class="flex flex-column gap-2 text-sm font-semibold">
                    <div class="flex flex-column">
                      <span class="font-bold">Promotions</span>
                    </div>
                    @for (promotion of cartModel().videoCharges?.monthly.promotions?.items; track promotion) {
                      <div class="flex justify-content-between">
                        <span [innerHTML]="promotion.name"></span>
                        <span class="positive-base">{{ promotion.amount| currency }}</span>
                      </div>
                      @if (promotion.disclosure) {
                        <div class="font-light font-product">
                          <span [innerHTML]="promotion.disclosure"></span>
                        </div>
                      }
                    }
                    <p-divider class="flex justify-content-center w-full"></p-divider>
                    <div class="flex justify-content-between positive-base">
                      <span>Total Savings</span>
                      <span>{{ cartModel().videoCharges?.monthly?.promotions?.totalAmount |
                        currency
                      }}</span>
                    </div>
                  </div>
                </div>
              }
              <div class="p-2" style="border-top: 1px solid;">
                @if (cartModel().videoCharges?.monthly?.totalTaxAmount) {
                  <div class="mb-2 flex justify-content-between font-bold"
                    >
                    <span>Tax</span>
                    <span>{{cartModel().videoCharges?.monthly?.totalTaxAmount | currency}} </span>
                  </div>
                }
                <div class="mb-2 flex justify-content-between font-bold">
                  <span>Total </span>
                  <span>{{cartModel().videoCharges?.monthly?.totalAmount | currency}} </span>
                </div>
              </div>
            </div>
          </div>
        }
        @if (cartModel().voiceCharges) {
          <div class="flex flex-column ">
            <div class="justify-content-center align-items-center mt-3 dashed">
              <div class="flex align-items-center justify-content-center mb-4">
                <div class="border-top-1 surface-800 flex-1 bg-black-alpha-40"></div>
                <span class="text-sm font-bold text-primary px-3">Voice</span>
                <div class="border-top-1 surface-800 flex-1 bg-black-alpha-40"></div>
              </div>
            </div>
            <div class="border-1 border-round-xl border-black-alpha-20 bg-gray p-2 pb-0 mb-2 p-3 border-round-xl text-sm font-semibold gap-3 flex flex-column"
              style="background-color: #F0F0F0;">
              <div class="p-2 pb-0">
                <div class="mb-2 flex justify-content-between font-bold">
                  <span [innerHTML]="cartModel().voiceCharges?.name"></span>
                  <span>{{cartModel().voiceCharges?.price | currency}} </span>
                </div>
              </div>
              @for (category of cartModel().voiceCharges?.monthly?.items; track category) {
                <div>
                  <div class="p-2 pb-0">
                    <div class="mb-2 flex justify-content-between font-bold">
                      <span [innerHTML]="category?.name"></span>
                      @if (category?.showIncludedLabel) {
                        <span>Included</span>
                      } @else {
                        <span>{{category?.amount | currency}}</span>
                      }
                    </div>
                  </div>
                  @if (category?.disclosure) {
                    <div class="flex pb-2 pl-3">
                      <span class="text-primary-700" [innerHTML]="category?.disclosure"></span>
                    </div>
                  }
                </div>
              }
              @if (cartModel().voiceCharges?.monthly?.promotions?.items?.length > 0) {
                <div class="w-full align-self-center p-4 border-round-lg bg-white">
                  <div class="flex flex-column gap-2 text-sm font-semibold">
                    <div class="flex flex-column">
                      <span class="font-bold">Promotions</span>
                    </div>
                    @for (promotion of cartModel().voiceCharges?.monthly.promotions?.items; track promotion) {
                      <div class="flex justify-content-between">
                        <span [innerHTML]="promotion.name"></span>
                        <span class="positive-base">{{ promotion.amount| currency }}</span>
                      </div>
                      @if (promotion.disclosure) {
                        <div class="font-light font-product">
                          <span [innerHTML]="promotion.disclosure"></span>
                        </div>
                      }
                    }
                    <p-divider class="flex justify-content-center w-full"></p-divider>
                    <div class="flex justify-content-between positive-base">
                      <span>Total Savings</span>
                      <span>{{ cartModel().voiceCharges?.monthly?.promotions?.totalAmount | currency
                      }}</span>
                    </div>
                  </div>
                </div>
              }
              <div class="p-2" style="border-top: 1px solid;">
                @if (cartModel().voiceCharges?.monthly?.totalTaxAmount) {
                  <div class="mb-2 flex justify-content-between font-bold"
                    >
                    <span>Tax</span>
                    <span>{{cartModel().voiceCharges?.monthly?.totalTaxAmount | currency}} </span>
                  </div>
                }
                <div class="mb-2 flex justify-content-between font-bold">
                  <span>Total: </span>
                  <span>{{cartModel().voiceCharges?.monthly?.totalAmount | currency}} </span>
                </div>
              </div>
            </div>
          </div>
        }
        <!-- <div class="flex flex-column " *ngIf="videoPackageSelected() && currentFlow() === 'Video'">
        <div class="mb-3 flex justify-content-center align-items-center mt-2 dashed">
          <span class="font-product font-bold">Video</span>
        </div>
        <div class="border-1 border-round-xl border-black-alpha-20 bg-gray p-2 pb-0 mb-2">
          <div class="p-2 pb-0">
            <div class="mb-2 flex justify-content-between font-bold">
              <span>{{videoPackageSelected()?.ComponentName}}</span>
              <span>{{videoPackageSelected()?.Price | currency}} </span>
            </div>
          </div>
          <ng-container *ngFor="let category of videoCategory()">
            <div class="p-2 pb-0">
              <div class="mb-2 flex justify-content-between font-bold">
                <span>{{category?.Name}}</span>
                @if (category?.Fee?.Fee > 0 || category?.Fee?.Fee < 0) { <span>{{category?.Fee.Fee |
                currency}}</span>
              } @else {
                <span>Included</span>
              }
            </div>
          </div>
          <div class="flex pb-2 pl-3" *ngIf="category?.CartDisclosure">
            <span class="text-primary-700">{{category?.CartDisclosure}}</span>
          </div>
        </ng-container>
        <div class="p-2" style="border-top: 1px solid;">
          <div class="mb-2 flex justify-content-between font-bold">
            <span>Video Total </span>
            <span>{{videoChargesTotal() | currency}} </span>
          </div>
        </div>
      </div>
    </div> -->
    @if (cartModel().packagesCharges?.items.length) {
      <div class="flex flex-column ">
        <div class="mb-3 flex justify-content-center align-items-center mt-2 dashed">
          <span class="font-product font-bold">Package Discounts & Fees</span>
        </div>
        <div class="border-1 border-round-xl border-black-alpha-20 bg-gray p-2 pb-0 mb-2">
          @for (category of cartModel().packagesCharges?.items; track category) {
            <div class="p-2 pb-0">
              <div class="mb-2 flex justify-content-between font-bold">
                <span>{{category?.name}}</span>
                <span>{{category?.amount | currency}}</span>
              </div>
            </div>
            @if (category?.disclosure) {
              <div class="flex pb-2 pl-3">
                <span class="text-primary-700">{{category?.disclosure}}</span>
              </div>
            }
          }
          <div class="p-2" style="border-top: 1px solid;">
            <div class="mb-2 flex justify-content-between font-bold">
              <span>Total </span>
              <span>{{cartModel().packagesCharges?.totalAmount| currency}} </span>
            </div>
          </div>
        </div>
      </div>
    }
    @if (cartModel().savingAndPromotionCharges?.items.length) {
      <div class="flex flex-column ">
        <div class="mb-3 flex justify-content-center align-items-center mt-2 dashed">
          <span class="font-product font-bold">Savings & Promotions</span>
        </div>
        <div class="border-1 border-round-xl border-black-alpha-20 bg-gray p-2 pb-0 mb-2">
          @for (reward of cartModel().savingAndPromotionCharges?.items; track reward) {
            <div class="p-2">
              <div class="mb-1 flex justify-content-between font-bold">
                <span>{{reward?.name}}</span>
                <span>{{reward?.amount | currency}}</span>
              </div>
            </div>
            @if (reward?.disclosure) {
              <div class="flex pl-3 pb-2">
                <span class="text-primary-700" [innerHTML]="reward?.disclosure"></span>
              </div>
            }
          }
        </div>
      </div>
    }
    <div class="flex flex-column  mt-2">
      <div class="mb-2 flex justify-content-center align-items-center py-2 border-round-lg sara-header-bg">
        <span class="text-white text-base font-semibold">Total Monthly Charges</span>
      </div>
      <div style="background-color: #F0F0F0;" class="flex flex-column p-3 border-round-xl">
        @if (cartModel().internetCharges?.monthly) {
          <div>
            <div class="mb-2 flex justify-content-between font-semibold text-sm">
              <span>Internet Total*: </span>
              <span>{{cartModel().internetCharges.monthly.totalAmount| currency}} </span>
            </div>
            <!-- <span class="text-sm font-light">
            ** Plus taxes and fees. Price higher after discount(s) removed or promo(s)
            end.
          </span> -->
          <p-divider class="flex justify-content-center w-full"></p-divider>
        </div>
      }
      @if (cartModel().voiceCharges?.monthly) {
        <div>
          <div class="mb-2 flex justify-content-between font-semibold text-sm">
            <span>Voice Total*: </span>
            <span>{{cartModel().voiceCharges.monthly.totalAmount | currency}}</span>
          </div>
          <p-divider class="flex justify-content-center w-full"></p-divider>
        </div>
      }
      @if (cartModel().wirelessCharges?.totalMonthlyAmount) {
        <div>
          <div class="mb-2 flex justify-content-between font-semibold text-sm">
            <span>Wireless Total*: </span>
            <span>{{cartModel().wirelessCharges?.totalMonthlyAmount | currency}}</span>
          </div>
          <!-- <span class="text-sm font-light">
          ** Plus taxes and fees. Price higher after discount(s) removed or promo(s)
          end.
        </span> -->
        <p-divider class="flex justify-content-center w-full"></p-divider>
      </div>
    }
    <!-- <div *ngIf="videoChargesTotal() && currentFlow() === 'Video'">
    <div class="mb-2 flex justify-content-between font-semibold text-sm">
      <span>Video Total*: </span>
      <span>{{videoChargesTotal() ?? 0 | currency}}</span>
    </div>
    <span class="text-sm font-light">
      ** Plus taxes and fees. Price higher after discount(s) removed or promo(s)
      end.
    </span>
    <p-divider class="flex justify-content-center w-full"></p-divider>
  </div> -->
  <div>
    <div class="mb-2 flex justify-content-between font-semibold text-sm">
      <span>Monthly Total*: </span>
      <span>{{cartModel().monthlyTotal | currency}}</span>
    </div>
    <span class="text-sm font-light">
      ** Plus taxes and fees. Price higher after discount(s) removed or promo(s)
      end.
    </span>
  </div>
</div>
</div>
</p-scrollPanel>
}
@if (cartStateService.isCartEmpty()) {
  <div class="flex align-items-center px-6 py-3 xl:border-1 border-black-alpha-40 border-round-xl">
    <i class="pi pi-bundle-empty-cart mr-2"></i>
    <span>Your Cart is <b>Empty</b></span>
  </div>
}
}
